export default {
  fields: {
    online_shop_domain: 'Dominio proprio per il negozio online',
    online_shop_domain_hint:
      'Un dominio del ristorante, ad esempio order.pizzeria-mario.com — solo per gli ordini; un sito web ne richiede un altro. Una volta salvato, qui compaiono i record da aggiungere.',
    online_shop_domain_placeholder: 'order.pizzeria-mario.com',
  },
};
